var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollContainer",
      staticClass: "chat-window__messages flex-grow-1 overflow-y-auto pa-3",
      on: { scroll: _vm.onScroll }
    },
    [
      _vm.loading && (!_vm.mensagens || !_vm.mensagens.length)
        ? [
            _c(
              "div",
              { staticClass: "d-flex justify-center my-3" },
              [
                _c("BaseLoadingSkeleton", {
                  staticClass: "rounded-pill",
                  attrs: { width: "80px", height: "24px" }
                })
              ],
              1
            ),
            _vm._l(6, function(i) {
              return _c(
                "div",
                {
                  key: "msg-skeleton-" + i,
                  staticClass: "d-flex mb-3",
                  class: i % 2 === 0 ? "justify-start" : "justify-end"
                },
                [
                  _c("BaseLoadingSkeleton", {
                    staticClass: "rounded-lg",
                    attrs: { width: 120 + i * 20 + "px", height: "48px" }
                  })
                ],
                1
              )
            })
          ]
        : [
            _vm.loadingOlder
              ? _c(
                  "output",
                  { staticClass: "d-flex flex-column align-center pa-2" },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        indeterminate: "",
                        size: "24",
                        width: "2",
                        color: "grey"
                      }
                    }),
                    _vm.olderLoadingLabel
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "az-text-small az-muted mt-1 text-center"
                          },
                          [_vm._v(" " + _vm._s(_vm.olderLoadingLabel) + " ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm.beginningOfConversation
              ? _c("output", { staticClass: "d-block text-center pa-2" }, [
                  _c("span", { staticClass: "az-text-small az-muted" }, [
                    _vm._v(" " + _vm._s(_vm.beginningLabel) + " ")
                  ])
                ])
              : _vm._e(),
            _vm._l(_vm.messagesWithDateSeparators, function(item) {
              return [
                item._isSeparator
                  ? _c(
                      "div",
                      {
                        key: item._separatorId,
                        staticClass: "d-flex align-center justify-center my-3"
                      },
                      [
                        _c("ChatBadge", {
                          attrs: { variant: "date", text: item._label }
                        })
                      ],
                      1
                    )
                  : _c("ChatMessage", {
                      key: item.id,
                      attrs: {
                        mensagem: item,
                        "linked-task-id": _vm.linkedTaskFor(item.id),
                        api: _vm.api,
                        namespace: _vm.namespace,
                        "hide-note": _vm.hideNote,
                        "hide-task": _vm.hideTask,
                        "has-linked-client": _vm.hasLinkedClient,
                        "id-cliente-app": _vm.idClienteApp,
                        "hide-phone-fallback": _vm.hidePhoneFallback,
                        "show-canal-badge": _vm.showCanalBadge,
                        "data-message-id": item.id,
                        "data-whatsapp-id": item.whatsapp_message_id || ""
                      },
                      on: {
                        retry: _vm.onRetry,
                        reply: _vm.onReply,
                        edit: _vm.onEdit,
                        react: _vm.onReact,
                        note: _vm.onNote,
                        delete: _vm.onDelete,
                        "create-task": _vm.onCreateTask,
                        "send-to-drive": _vm.onSendToDrive,
                        "send-to-drive-rename": _vm.onSendToDriveRename,
                        "open-task": _vm.onOpenTask,
                        "scroll-to-message": _vm.onScrollToMessage
                      }
                    })
              ]
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }